import React from 'react';
import Dropzone from 'react-dropzone';

import SVGIcon, { GENERAL_ICONS } from 'src/components/svg';

import { lang } from 'src/helpers';
import { MCButton } from '../basic';
import AlertManager from '../alert/AlertManager';
import LANG_CONST from '../../helpers/lang/const';

export class DropProgressBox extends React.PureComponent {
  onUpload = (files) => {
    const handler = this.props.onDrop || this.props.onUpload;
    handler && handler(this.props.name, files);
  };

  reject = () => {
    AlertManager.popup(AlertManager.TYPES.WARN, {
      close: false,
      title: LANG_CONST.validation.file_invalid,
      actionButton: {
        label: LANG_CONST.buttons.ok,
        action: (actions) => actions.hide()
      }
    });
  };

  render() {
    let {
      invalid,
      name,
      type = 'default',
      dropBoxStyles = {},
      accept,
      childComp: ChildComp = null,
      testId = 'drop-progress-box',
      inputTestId = 'drop-progress-input'
    } = this.props;
    return (
      <Dropzone onDropAccepted={this.onUpload} onDropRejected={this.reject} accept={accept}>
        {({ getRootProps, getInputProps }) => {
          const { onClick, ...rootProps } = getRootProps({
            className: 'mc-drop-progress-box mc-dropbox-' + type,
            style: dropBoxStyles,
            'data-testid': testId
          });
          return (
            <div {...rootProps}>
              <input {...getInputProps({ 'data-testid': inputTestId })} />
              {ChildComp ? (
                <ChildComp onClick={onClick} />
              ) : (
                <>
                  <SVGIcon iconname={GENERAL_ICONS.UPLOAD} />
                  <div>{lang.t(LANG_CONST.buttons.drag_upload)}</div>
                  <div>{lang.t(LANG_CONST.or)}</div>
                  <MCButton
                    label={LANG_CONST.buttons.upload_diploma}
                    primary
                    medium
                    outline
                    radius
                    onClick={onClick}
                  />
                </>
              )}
              {invalid && invalid[name] && (
                <div className='mc-form-invalid-text'>{invalid[name]}</div>
              )}
            </div>
          );
        }}
      </Dropzone>
    );
  }
}
